import React, { Fragment, useEffect, useState, useMemo, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Row, Col, Card, Table } from "react-bootstrap";
import { styled } from "@mui/material/styles";
// import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import Papa from "papaparse";
import {
  cutAfterDecimal,
  getActiveUserList,
  getAllStakeUsers,
  getAllUserList,
  getTeamdata,
} from "../../../services/api_function";
import toast from "react-hot-toast";
import { Tooltip, IconButton } from "@mui/material";
import { FaRegCopy } from "react-icons/fa";
import { data } from "autoprefixer";

export const TeamList = () => {
  const location = useLocation();
  const userGet = new URLSearchParams(location.search).get("user");
  const itemsPerPage = 50;
  const [apiData, setApiData] = useState([]);
  const [count, setCount] = useState(0);
  const [TotalUsers, setTotalUsers] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [search, setSearch] = useState("");
  const [daoAddress, setDaoAddress] = useState("");
  const [recordStatus, setRecordStatus] = useState("Loading...");
  const [isFetch, setIsFetch] = useState(false);
  const [teamLevel, setTeamLevel] = useState([]);

  const [tooltipText, setTooltipText] = useState("Copy address");

  const handleCopy = (address) => {
    navigator.clipboard.writeText(address);
    setTooltipText("Copied!");
    setTimeout(() => setTooltipText("Copy address"), 2000);
  };

  const handleSearch = async (e) => {
    const query = e.target.value.trim().toLowerCase();
    const sanitizedQuery = query.replace(/[\\|^$*+?.(){}[\]]/g, "");
    setSearch(sanitizedQuery);
    if (currentPage !== 1) {
      setCurrentPage(1);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const userDetails = localStorage.getItem("adminToken");
        const token = userDetails;
        const result = await getTeamdata(
          userGet,
          currentPage,
          50,
          search,
          token
        );
        setApiData(result?.data?.teamData);
        setTeamLevel(result?.data?.levelSum);
        if (!result?.data?.data?.[0]) {
          setRecordStatus("No Record");
        }
        setTotalUsers(result?.data?.pagination?.totalUsers);
        setTotalPages(result?.data?.pagination?.totalPages);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [currentPage, search, isFetch]);

  const handleNextPage = () => {
    setCurrentPage((prevPage) =>
      prevPage < totalPages ? prevPage + 1 : prevPage
    );
  };

  const handlePreviousPage = () => {
    setCurrentPage((prevPage) => (prevPage > 1 ? prevPage - 1 : prevPage));
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      Papa.parse(file, {
        complete: (result) => {
          console.log(result.data); // Logs the CSV data to console
        },
        header: true, // if you want the first row as headers
      });
    }
  };

  const handleClick = () => {
    document.getElementById("fileInput").click();
  };

  return (
    <Fragment>
      <Row>
        {teamLevel?.map((item, index) => (
          <div key={item?._id} className="col-xl-3 col-md-6">
            <div className="card custom-card">
              <div className="card-body">
                <p>Level: {item?._id}</p>
                <p>Total Stake: {Number(item?.totalAmount)?.toFixed(2)}</p>
                <p>User: {Number(item?.count)}</p>
              </div>
            </div>
          </div>
        ))}

        <Col lg={12}>
          <Card>
            <Card.Header>
              <Card.Title>Active User</Card.Title>
            </Card.Header>
            <Card.Body>
              <Table responsive>
                <thead>
                  <tr>
                    <th>S.No.</th>
                    <th>User id</th>
                    <th>User Wallet</th>
                    <th>Referral id</th>
                    <th>Name</th>
                    <th>Phone</th>
                    <th>Email</th>
                    <th>Total Stake</th>
                    <th>Level</th>
                    <th>Team Business</th>
                    <th>Team Size</th>
                    <th>Direct</th>
                    <th>Date & Time</th>
                  </tr>
                </thead>
                <tbody>
                  {!apiData?.[0] ? (
                    <tr>
                      <td className="text-light text-center" colSpan="7"></td>
                    </tr>
                  ) : (
                    apiData?.map((data, index) => (
                      <tr key={index}>
                        <td>{index + 1 + (currentPage - 1) * itemsPerPage}</td>
                        <td>{data?.userId} </td>
                        <td>
                          {data?.user?.slice(0, 5)}...{data?.user?.slice(-4)}
                          <Tooltip title={tooltipText} arrow>
                            <IconButton
                              onClick={() => handleCopy(data?.user)}
                              size="small"
                              style={{ marginLeft: 4 }}
                            >
                              <FaRegCopy />
                            </IconButton>
                          </Tooltip>
                        </td>
                        <td>{data?.referrerId} </td>

                        <td>{data?.name}</td>

                        <td>{data?.phone}</td>

                        <td>{data?.email}</td>

                        <td>{Number(data?.totalStake).toFixed(2)}</td>
                        <td>{data?.level}</td>
                        <td>{Number(data?.teamBusness)?.toFixed(2)}</td>

                        <td>{data?.totalTeam}</td>

                        <td>{data?.directTeam}</td>

                        <td>
                          {new Date(data?.createdAt).toLocaleString("en-GB", {
                            day: "2-digit",
                            month: "2-digit",
                            year: "numeric",
                            hour: "2-digit",
                            minute: "2-digit",
                          })}
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </Table>

              <div className="d-flex justify-content-between">
                <span>
                  {/* Page{" "} */}
                  <strong>{/* {currentPage} of {totalPages} */}</strong>
                </span>
              </div>
              <div
                className="text-center mb-3 col-lg-6"
                style={{ margin: "auto" }}
              >
                <div className=" filter-pagination mt-3 ">
                  <button
                    className="previous-button btn border m-2"
                    onClick={handlePreviousPage}
                    disabled={currentPage === 1}
                  >
                    Previous
                  </button>

                  <button
                    type="button"
                    className="next-button btn btn-success pointer border m-2"
                    onClick={handleNextPage}
                    disabled={currentPage === totalPages}
                  >
                    Next
                  </button>

                  <span>
                    Page {currentPage} of {totalPages}
                  </span>
                  <span> Total users {TotalUsers}</span>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Fragment>
  );
};

export default TeamList;
